import { ref, onMounted } from 'vue'

const isDarkTheme = ref(false)

export function useTheme() {
  onMounted(() => {
    isDarkTheme.value = document.body.classList.contains('dark-theme')

    // Optional: auto-update when class changes
    const observer = new MutationObserver(() => {
      isDarkTheme.value = document.body.classList.contains('dark-theme')
    })
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
  })

  return { isDarkTheme }
}
